var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessIconinline = function SvgSuccessIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D822B",
    d: "M10 0a10 10 0 1 0 10 10A10.02 10.02 0 0 0 10 0m4.76 8.25-5.635 5.385a.78.78 0 0 1-.538.211.74.74 0 0 1-.53-.211L5.24 10.942a.77.77 0 1 1 1.058-1.115l2.289 2.183 5.115-4.875A.77.77 0 0 1 14.76 8.25"
  })));
};
export default SvgSuccessIconinline;